// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"94":"Login","389":"404","594":"about","639":"Sincronizar","887":"Dash"}[chunkId] + "." + {"94":"01e515a3","389":"ba5a3702","594":"a1caac4a","639":"a1caac4a","887":"bdbf3e37"}[chunkId] + ".css";
};